import React from 'react';

interface AgeChipTemplateProps {
  ageDays: number;
}

/**
 * Displays age in days with color-coded chip based on thresholds.
 * - Green: < 120 days
 * - Yellow: 120-179 days  
 * - Red: >= 180 days
 */
export const AgeChipTemplate: React.FC<AgeChipTemplateProps> = ({ ageDays }) => {
  let backgroundColor = '#d4edda'; // light green
  let color = '#155724'; // dark green

  if (ageDays >= 180) {
    backgroundColor = '#f8d7da'; // light red
    color = '#721c24'; // dark red
  } else if (ageDays >= 120) {
    backgroundColor = '#fff3cd'; // light yellow
    color = '#856404'; // dark yellow
  }

  return (
    <div
      style={{
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '16px',
        backgroundColor,
        color,
        fontWeight: 600,
        fontSize: '0.85rem',
        lineHeight: '1.5',
      }}
    >
      {ageDays}d
    </div>
  );
};

/** Syncfusion grid template wrapper */
export const ageTemplate = (props: any) => <AgeChipTemplate ageDays={props.ageDays} />;

export default AgeChipTemplate;
